import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { selectTicketOrNoteDraftFilteredMentionableAgents } from 'selectors/mentions'
import {
  doUpdateAgentMention,
  doUpdateSelectedMentionSelectorAgentId,
  doUpdateSuppressMentionSelector,
} from 'actions/app'
import { doMentionAgent } from 'actions/tickets'
import MentionsDropdown from './view'

const select = state => ({
  items: selectTicketOrNoteDraftFilteredMentionableAgents(state),
})

const perform = dispatch => ({
  ...bindActionCreators(
    {
      doUpdateAgentMention,
      doUpdateSelectedMentionSelectorAgentId,
      doUpdateSuppressMentionSelector,
    },
    dispatch
  ),
  onSelect: (ticketId, agent) => dispatch(doMentionAgent(agent.id, ' ')),
  onFocus: (index, agent) => {
    return dispatch(doUpdateSelectedMentionSelectorAgentId(agent.id))
  },
})

export default connect(select, perform)(MentionsDropdown)
